import React, { useCallback, useState } from 'react';
import FavoritedIcon from './star-solid.svg';
import Link from '../../../../../elements/Link';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import styles from './FavoriteSession.module.scss';
import { app } from '../../../../../../app';

function FavoriteSession(props) {
    const { event, session } = props,
        i18n = useI18n(),
        [busy, setBusy] = useState(false);

    const handeClick = useCallback(() => {
        setBusy(true);
        app.api.program.favoriteSession(event.id, session.id, !session.is_favorite).finally(() => setBusy(false));
    }, [event, session]);

    return (
        <Link className={[styles.FavoriteSession, session.is_favorite ? styles.favorite : ''].join(' ')} onClick={!busy ? handeClick : null}>
            <FavoritedIcon />
            <br />
            {i18n['label.favorite']}
        </Link>
    );
}

export default FavoriteSession;
